module.exports = __webpack_public_path__ + "img/326553174_432033092402422_2273263281716716494_n.7f2ce2dc.jpg";